<template>
  <div>
    <v-data-table
      :headers="headers"
      :loading="loading_message"
      :items="rider_wallet_transaction"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">
          {{ rider_wallet_transaction.indexOf(props.item) + 1 }}
        </td>
        <td class="text-xs-center">{{ props.item.wt_date }}</td>
        <td class="text-xs-center">{{ props.item.wt_time }}</td>
        <td class="text-xs-right">
          {{
            parseFloat(props.item.wt_after_money)
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }}
        </td>
        <td class="text-xs-right">
          {{
            parseFloat(props.item.wt_after_credit)
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }}
        </td>
        <td>{{ props.item.wt_detail }}</td>
        <td
          class="text-xs-right"
          :style="{ color: calMoney(props.item) > 0 ? 'green' : 'red' }"
        >
          {{ calMoney(props.item) > 0 ? "+" : "" }}{{ calMoney(props.item) }}
        </td>
      </template>

      <!-- <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.item.wt_date }}</td>
        <td class="text-xs-center">{{ props.item.wt_time }}</td>
        <td class="text-xs-center">{{ props.item.wt_before_money }}</td>
        <td class="text-xs-center">{{ props.item.wt_before_credit }}</td>
        <td class="text-xs-center">{{ props.item.wt_money }}</td>
        <td class="text-xs-center">{{ props.item.wt_credit }}</td>
        <td class="text-xs-center">{{ props.item.wt_after_money }}</td>
        <td class="text-xs-center">{{ props.item.wt_after_credit }}</td>
        <td class="text-xs-center">{{ props.item.wt_action }}</td>
        <td class="text-xs-center">{{ props.item.wt_detail }}</td>
      </template>-->

      <template slot="no-data">
        <div class="text-xs-center" v-if="loading_message == false">
          No data available
        </div>
        <div class="text-xs-center" v-else>
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          ></v-progress-circular
          >Loading data ...
        </div>
      </template>
    </v-data-table>

    <!-- <div class="text-xs-center py-2">
      <v-pagination circle v-model="pagination.page" :length="pages"></v-pagination>
    </div>-->
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  props: { loading_message: {} },
  data: () => ({
    pagination: {
      page: 1,
      rowsPerPage: 10,
    },
    headers: [
      {
        text: "No.",
        align: "center",
        value: "id",
        sortable: false,
      },
      {
        text: "Date",
        align: "center",
        value: "date",
        sortable: false,
      },
      {
        text: "Time",
        align: "center",
        value: "time",
        sortable: false,
      },
      {
        text: "Cash",
        align: "center",
        value: "date",
        sortable: false,
      },
      {
        text: "Credit",
        align: "center",
        value: "time",
        sortable: false,
      },
      {
        text: "Details",
        align: "center",
        value: "b_cash",
        sortable: false,
      },
      {
        text: "Changed",
        align: "center",
        value: "b_credit",
        sortable: false,
      },
    ],
  }),
  computed: {
    ...mapState({
      rider_wallet_transaction: (state) =>
        state.fetchCashRider.rider_wallet_transaction,
    }),
    pages() {
      this.pagination.totalItems = this.rider_wallet_transaction.length;
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
  },
  methods: {
    calMoney(item) {
      return parseFloat(
        parseFloat(item.wt_after_money) -
          parseFloat(item.wt_before_money) +
          (parseFloat(item.wt_after_credit) - parseFloat(item.wt_before_credit))
      ).toFixed(2);
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  async created() {},
};
</script>
